import styled from 'styled-components';

const StyledTextAreaFieldComponent = styled.div`
    .se-text-area-field-label{
      font-family:SemiBold;
      font-size: 13px;
      color: var(--secondaryColor);
      padding-bottom:6px;
      display: flex;
    }
    &.se-text-area-field-component-wrapper{
        display:flex;
        flex-direction:column;
    }
    .se-text-area-field-component{
        width: 100%;
        font-family: Regular;
        font-size: 13px;
        resize: none;
        color: var(--secondaryColor);
        border-radius: 2px;
        background-color:var(--white);
        border: 1px solid var(--borderColor);
        min-height: 32px;
        padding: 6px 11px;
        box-sizing: border-box;
        outline: none;

        :focus-visible {
            border-color: var(--border);
        }

        ::placeholder {
            color: var(--searchBoxTextColor);
        }

        :hover {
            border-color: var(--border);
        }

    }
    .danger {
        border-color: var(--dangerColor) !important;
    }

    .se-text-area-field-error {
        font: 12px Regular;
        color: var(--dangerColor);
        margin-top: 6px;
    }

  


`;
export const StyledColumnDescriptionWrapper = styled.div`
    margin-bottom: 16px;

    .se-column-description-textarea-cn {
        position: relative;
    }

    .se-column-description-textarea {
        min-height: 64px;
        max-height: 96px;
        padding: 6px 4px 6px 12px;
        resize: vertical;

        &::-webkit-resizer {
            background-color: transparent;
            background-image: none;
        }
    }

    .se-resize-icon {
        position: absolute;
        right: 6px;
        bottom: 8px;
        width: 8px;
        height: 8px;
        line-height: 0;
        pointer-events: none;
    }

    .se-column-description-error {
        font: 13px Regular;
        line-height: 20px;
        color: var(--dangerColor);
        margin-top: 4px;
    }
`;

export default StyledTextAreaFieldComponent;
